module.exports = __webpack_public_path__ + "img/4.305de966.jpg";